// src/services/firebase.js

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';
import { 
  getFirestore,
  collection,
  query,
  where,
  orderBy,
  getDocs,
  getDoc,
  doc,
  updateDoc,
  setDoc,
  addDoc,
  serverTimestamp,
  Timestamp
} from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCem52EJ8L2KH9pFHpQQ9Y9Fa3Om-HsOA4",
  authDomain: "caryny.firebaseapp.com",
  projectId: "caryny",
  storageBucket: "caryny.firebasestorage.app",
  messagingSenderId: "1071941425715",
  appId: "1:1071941425715:web:0f57153e9c61a2ca216146",
  measurementId: "G-W71WHTDD3Q"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

// Helper function to generate default availability slots
const generateDefaultAvailabilitySlots = () => {
  const slots = [];
  for (let day = 0; day < 7; day++) {
    for (let hour = 0; hour < 24; hour++) {
      slots.push({
        dayOfWeek: day,
        hour: hour,
        isAvailable: false
      });
    }
  }
  return slots;
};

// Helper function to create default GP document
const createDefaultGPDoc = (username, email) => ({
  username: username,
  email: email,
  name: username,
  photoUrl: '',
  whatsapp: '',
  videoUrl: '',
  audioUrl: '',
  pictures: Array(12).fill(''),
  services: {
    podolatria: false,
    sexo_anal: false,
    massagem: false,
    oral: false
  },
  availabilitySlots: generateDefaultAvailabilitySlots(),
  createdAt: serverTimestamp(),
  updatedAt: serverTimestamp()
});

// Export Firebase instances and Firestore functions
export { 
  db, 
  auth, 
  storage, 
  analytics,
  collection,
  query,
  where,
  orderBy,
  getDocs,
  getDoc,
  doc,
  updateDoc,
  setDoc,
  addDoc,
  serverTimestamp as timestamp,
  Timestamp
};

// Export helper functions
export { createDefaultGPDoc };

// Authentication methods
export const signIn = async (email, password) => {
  try {
    const userCredential = await auth.signInWithEmailAndPassword(email, password);
    return userCredential.user;
  } catch (error) {
    throw error;
  }
};

export const signOut = async () => {
  try {
    await auth.signOut();
  } catch (error) {
    throw error;
  }
};

// Firestore methods
export const createBooking = async (bookingData) => {
  try {
    // Verificar se o Firebase está inicializado
    if (!db) {
      throw new Error('Firebase não está inicializado');
    }

    // Criar referência para a coleção bookings
    const bookingsRef = collection(db, 'bookings');
    
    // Adicionar documento
    const docRef = await addDoc(bookingsRef, {
      ...bookingData,
      createdAt: serverTimestamp()
    });

    // Verificar se o documento foi criado
    if (!docRef.id) {
      throw new Error('Falha ao criar o agendamento');
    }

    return docRef.id;
  } catch (error) {
    console.error('Erro ao criar agendamento:', error);
    throw error;
  }
};

export const getBookings = async (username) => {
  try {
    const bookingsRef = collection(db, 'bookings');
    const q = query(bookingsRef, where('username', '==', username));
    const querySnapshot = await getDocs(q);
    
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
  } catch (error) {
    console.error('Erro ao buscar agendamentos:', error);
    throw error;
  }
};

export const updateBookingStatus = async (bookingId, status) => {
  try {
    const bookingRef = doc(db, 'bookings', bookingId);
    await updateDoc(bookingRef, {
      status,
      updatedAt: serverTimestamp()
    });
  } catch (error) {
    console.error('Erro ao atualizar status do agendamento:', error);
    throw error;
  }
};

export const getGPBookings = async (gpId) => {
  try {
    const bookingsRef = collection(db, 'bookings');
    const q = query(bookingsRef, where('gpId', '==', gpId), orderBy('createdAt', 'desc'));
    const querySnapshot = await getDocs(q);
    
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
  } catch (error) {
    throw error;
  }
};

export const updateGPAvailability = async (gpId, availability) => {
  try {
    const availabilityRef = doc(db, 'availability', gpId);
    await setDoc(availabilityRef, availability);
  } catch (error) {
    throw error;
  }
};

export const getGPAvailability = async (gpId) => {
  try {
    const availabilityRef = doc(db, 'availability', gpId);
    const docSnap = await getDoc(availabilityRef);
    return docSnap.exists() ? docSnap.data() : null;
  } catch (error) {
    throw error;
  }
};
